import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../common/assets/gfps-logo.png";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function InvalidRoute(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBackToHome = () => {
    navigate(props.homeUrl, { replace: true });
  };

  return (
    <Container fluid className="vh-100">
      <Row className="justify-content-center align-items-center h-100">
        <Col
          xs={8}
          sm={6}
          md={6}
          lg={4}
          xl={3}
          className="shadow p-3 rounded-3"
        >
          <Form>
            <Form.Group className="text-center">
              <img src={logo} height="100" alt="GfPS" title="GfPS" />
            </Form.Group>
            <Form.Group className="mb-4">
              <p>{t("KEY_PAGE_NOT_AVAILABLE")}</p>
            </Form.Group>
            <Button
              className="form-control"
              variant="primary text-white"
              onClick={handleBackToHome}
            >
              <FontAwesomeIcon className="me-1" icon={faHome} />
              {t("KEY_BACK_TO_HOME")}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}
